const styles = (theme) => {
  return {
    container: {
      display: 'grid',
      width: '100vw',
      height: '100vh',
      gridGap: '1rem',
      // gridTemplateColumns: 'auto',
      gridTemplateRows: '19% auto 3em',
      justifyContent: 'center',
      //alignItems:'center',
      // backgroundImage: 'linear-gradient(135deg, white, #dedede)',
      alignItems: 'normal',
      paddingTop: '105px',
      backgroundColor: 'white'
    },
    '@media screen and (max-width: 1080px)': {
      container: {
        display: 'grid',
        width: '100vw',
        height: '100vh',
        gridGap: '1rem',
        gridTemplateColumns: 'auto',
        gridTemplateRows: '10% auto 3em',
        // backgroundImage: 'linear-gradient(135deg, white, #dedede)',
        alignItems: 'normal',
        paddingTop: '105px',
        backgroundColor: 'white'
      }
    }
  };
};

export default styles;
